import { createContext } from 'react';
export type departureCitiesContextType = {
  departureCities: Array<{
    label: string;
    value: string;
  }>;
  setDepartureCities: (arg0: any) => void;
};
export default createContext<departureCitiesContextType>({
  departureCities: [],
  setDepartureCities: () => {},
});
